<template>
  <!-- Sidebar -->
  <div id="sidebar-wrapper" class="d-none d-md-flex flex-column">
    <div class="sidebar-brand">
      <router-link tag="a" to="/" class="navbar-brand h4">RDAP Web</router-link>
    </div>
    <ul class="sidebar-nav">
      <router-link tag="li" to="/" active-class="active" exact>
        <a>
          <span class="nav-label">Home</span>
        </a>
      </router-link>
      <router-link tag="li" to="/about" active-class="active">
        <a>
          <span class="nav-label">About</span>
        </a>
      </router-link>
      <router-link tag="li" to="/help" active-class="active">
        <a>
          <span class="nav-label">Help</span>
        </a>
      </router-link>
    </ul>
    <div class="sidebar-nav-links">
      <p>Useful Links</p>
      <ul>
        <li>
          <a href="http://wq.apnic.net/static/search.html" target="_blank">
            Whois
          </a>
        </li>
        <li>
          <a href="https://www.apnic.net/static/whowas-ui/" target="_blank">
            Whowas
          </a>
        </li>
      </ul>
    </div>

    <div id="sidebar-icon" class="mt-auto ml-auto mr-4 mb-4" aria-expanded="false"></div>
  </div>
  <!-- /#sidebar-wrapper -->
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.sidebar-useful-links {
	bottom: 100px;
	left: 0;
	padding: 1rem;
	position: absolute;
	width: 100%;

	h4 {
		color: #cccccc;
		font-size: 1rem;
		margin-bottom: 1.25rem;
		border-bottom: 2px solid #3e3d3d;
	}

	ul {
		list-style: none inside;
		margin: 0;
		padding: 0;

		a {
			display: block;
			position: relative;
			color: #cccccc;
		}
	}
}
</style>
